//# sourceMappingURL=table.mjs.map
/// <reference types="./table.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $timestamp from "../../../gleam_time/gleam/time/timestamp.mjs";
import * as $json_ from "../../../tiamat/gleam/json_.mjs";
import * as $html_parser from "../../common/html_parser.mjs";
import * as $user_id from "../../data/auth/user_id.mjs";
import * as $kind from "../../data/docx/kind.mjs";
import * as $decrypt from "../../decrypt.mjs";
import { Ok, Error, toList, CustomType as $CustomType, makeError } from "../../gleam.mjs";

const FILEPATH = "src/data/proposal_element/table.gleam";

export class Table extends $CustomType {
  constructor(id, proposal_id, element_type, owner, content, doc_id_order, metadata, qa_order, ai_processing, updated_at, created_at) {
    super();
    this.id = id;
    this.proposal_id = proposal_id;
    this.element_type = element_type;
    this.owner = owner;
    this.content = content;
    this.doc_id_order = doc_id_order;
    this.metadata = metadata;
    this.qa_order = qa_order;
    this.ai_processing = ai_processing;
    this.updated_at = updated_at;
    this.created_at = created_at;
  }
}
export const Table$Table = (id, proposal_id, element_type, owner, content, doc_id_order, metadata, qa_order, ai_processing, updated_at, created_at) =>
  new Table(id,
  proposal_id,
  element_type,
  owner,
  content,
  doc_id_order,
  metadata,
  qa_order,
  ai_processing,
  updated_at,
  created_at);
export const Table$isTable = (value) => value instanceof Table;
export const Table$Table$id = (value) => value.id;
export const Table$Table$0 = (value) => value.id;
export const Table$Table$proposal_id = (value) => value.proposal_id;
export const Table$Table$1 = (value) => value.proposal_id;
export const Table$Table$element_type = (value) => value.element_type;
export const Table$Table$2 = (value) => value.element_type;
export const Table$Table$owner = (value) => value.owner;
export const Table$Table$3 = (value) => value.owner;
export const Table$Table$content = (value) => value.content;
export const Table$Table$4 = (value) => value.content;
export const Table$Table$doc_id_order = (value) => value.doc_id_order;
export const Table$Table$5 = (value) => value.doc_id_order;
export const Table$Table$metadata = (value) => value.metadata;
export const Table$Table$6 = (value) => value.metadata;
export const Table$Table$qa_order = (value) => value.qa_order;
export const Table$Table$7 = (value) => value.qa_order;
export const Table$Table$ai_processing = (value) => value.ai_processing;
export const Table$Table$8 = (value) => value.ai_processing;
export const Table$Table$updated_at = (value) => value.updated_at;
export const Table$Table$9 = (value) => value.updated_at;
export const Table$Table$created_at = (value) => value.created_at;
export const Table$Table$10 = (value) => value.created_at;

export class Metadata extends $CustomType {}
export const Metadata$Metadata = () => new Metadata();
export const Metadata$isMetadata = (value) => value instanceof Metadata;

function metadata_decoder() {
  return $decode.success(new Metadata());
}

export function decoder() {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decode.field(
        "content",
        $decode.string,
        (content) => {
          return $decode.field(
            "element_type",
            $kind.decoder(),
            (element_type) => {
              return $decode.field(
                "doc_id_order",
                $decode.int,
                (doc_id_order) => {
                  return $decode.field(
                    "metadata",
                    metadata_decoder(),
                    (metadata) => {
                      return $decode.field(
                        "proposal_id",
                        $decode.string,
                        (proposal_id) => {
                          return $decode.field(
                            "owner",
                            $decode.optional($user_id.decoder()),
                            (owner) => {
                              return $decode.field(
                                "qa_order",
                                $decode.int,
                                (qa_order) => {
                                  return $decode.field(
                                    "ai_processing",
                                    $decode.bool,
                                    (ai_processing) => {
                                      return $decrypt.optional_field(
                                        "updated_at",
                                        $decrypt.timestamp(),
                                        (updated_at) => {
                                          let updated_at$1 = $option.lazy_unwrap(
                                            updated_at,
                                            $timestamp.system_time,
                                          );
                                          return $decrypt.optional_field(
                                            "created_at",
                                            $decrypt.timestamp(),
                                            (created_at) => {
                                              let created_at$1 = $option.lazy_unwrap(
                                                created_at,
                                                $timestamp.system_time,
                                              );
                                              return $decode.success(
                                                new Table(
                                                  id,
                                                  proposal_id,
                                                  element_type,
                                                  owner,
                                                  content,
                                                  doc_id_order,
                                                  metadata,
                                                  qa_order,
                                                  ai_processing,
                                                  updated_at$1,
                                                  created_at$1,
                                                ),
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function encode_metadata(_) {
  return $json.object(toList([]));
}

export function encode(element) {
  return $json.object(
    toList([
      ["element_type", $json.string($kind.to_string(element.element_type))],
      ["id", $json.string(element.id)],
      ["content", $json.string(element.content)],
      ["doc_id_order", $json.int(element.doc_id_order)],
      ["metadata", encode_metadata(element.metadata)],
      ["proposal_id", $json.string(element.proposal_id)],
      ["owner", $json.nullable(element.owner, $user_id.encode)],
      ["qa_order", $json.int(element.qa_order)],
      ["ai_processing", $json.bool(element.ai_processing)],
      ["updated_at", $json_.to_rfc3339(element.updated_at)],
      ["created_at", $json_.to_rfc3339(element.created_at)],
    ]),
  );
}

/**
 * Map over the `tr` in `tbody`.
 */
export function map(node, mapper) {
  if (node instanceof $html_parser.EmptyElement) {
    return node;
  } else if (node instanceof $html_parser.StartElement) {
    let name = node.name;
    if (name === "tbody") {
      return new $html_parser.StartElement(
        node.name,
        node.attributes,
        mapper(node.children),
      );
    } else {
      return new $html_parser.StartElement(
        node.name,
        node.attributes,
        $list.map(node.children, (child) => { return map(child, mapper); }),
      );
    }
  } else if (node instanceof $html_parser.EndElement) {
    return node;
  } else {
    return node;
  }
}

function insert_elements(node, content) {
  return map(
    node,
    (children) => {
      return $list.index_map(
        children,
        (tr, y) => {
          if (tr instanceof $html_parser.EmptyElement) {
            return tr;
          } else if (tr instanceof $html_parser.StartElement) {
            return new $html_parser.StartElement(
              tr.name,
              tr.attributes,
              $list.index_map(
                tr.children,
                (td, x) => {
                  let $ = $dict.get(content, [x, y]);
                  if ($ instanceof Ok) {
                    if (td instanceof $html_parser.EmptyElement) {
                      return td;
                    } else if (td instanceof $html_parser.StartElement) {
                      let content$1 = $[0];
                      let content$2 = new $html_parser.Content(content$1);
                      return new $html_parser.StartElement(
                        td.name,
                        td.attributes,
                        toList([content$2]),
                      );
                    } else if (td instanceof $html_parser.EndElement) {
                      return td;
                    } else {
                      return td;
                    }
                  } else {
                    return td;
                  }
                },
              ),
            );
          } else if (tr instanceof $html_parser.EndElement) {
            return tr;
          } else {
            return tr;
          }
        },
      );
    },
  );
}

export function inject_questions(table, questions, answers) {
  let content = $html_parser.as_tree(table.content);
  let content$1 = insert_elements(content, questions);
  let content$2 = insert_elements(content$1, answers);
  let content$3 = $html_parser.render_html(content$2, 0);
  return new Table(
    table.id,
    table.proposal_id,
    table.element_type,
    table.owner,
    content$3,
    table.doc_id_order,
    table.metadata,
    table.qa_order,
    table.ai_processing,
    table.updated_at,
    table.created_at,
  );
}

/**
 * Get the `tbody`.
 */
export function tbody(node) {
  if (node instanceof $html_parser.EmptyElement) {
    return new Error(undefined);
  } else if (node instanceof $html_parser.StartElement) {
    let name = node.name;
    if (name === "tbody") {
      return new Ok(node);
    } else {
      return $list.fold_until(
        node.children,
        new Error(undefined),
        (acc, child) => {
          let $ = tbody(child);
          if ($ instanceof Ok) {
            let child$1 = $[0];
            return new $list.Stop(new Ok(child$1));
          } else {
            return new $list.Continue(acc);
          }
        },
      );
    }
  } else if (node instanceof $html_parser.EndElement) {
    return new Error(undefined);
  } else {
    return new Error(undefined);
  }
}

export function extract_questions_answers(table) {
  let content = $html_parser.as_tree(table.content);
  let $ = tbody(content);
  if ($ instanceof Ok) {
    let tbody$1 = $[0];
    if (!(tbody$1 instanceof $html_parser.StartElement)) {
      throw makeError(
        "let_assert",
        FILEPATH,
        "data/proposal_element/table",
        106,
        "extract_questions_answers",
        "Pattern match failed, no pattern matched the value.",
        {
          value: tbody$1,
          start: 3119,
          end: 3166,
          pattern_start: 3130,
          pattern_end: 3158
        }
      )
    }
    return $list.index_fold(
      tbody$1.children,
      $dict.new$(),
      (content, tr, y) => {
        if (tr instanceof $html_parser.EmptyElement) {
          return content;
        } else if (tr instanceof $html_parser.StartElement) {
          return $list.index_fold(
            tr.children,
            content,
            (content, td, x) => {
              if (td instanceof $html_parser.EmptyElement) {
                return content;
              } else if (td instanceof $html_parser.StartElement) {
                let _pipe = td.children;
                let _pipe$1 = $list.map(
                  _pipe,
                  (_capture) => { return $html_parser.render_html(_capture, 0); },
                );
                let _pipe$2 = $string.join(_pipe$1, "");
                return ((_capture) => {
                  return $dict.insert(content, [x, y], _capture);
                })(_pipe$2);
              } else if (td instanceof $html_parser.EndElement) {
                return content;
              } else {
                return content;
              }
            },
          );
        } else if (tr instanceof $html_parser.EndElement) {
          return content;
        } else {
          return content;
        }
      },
    );
  } else {
    return $dict.new$();
  }
}
